import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild, ViewContainerRef
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ContactUsProfileService } from 'src/app/services/contact-us-profile.service';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { ContactFormComponent } from '../contact-form/contact-form.component';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contact_us',
  templateUrl: './contact_us.component.html',
  styleUrls: ['./contact_us.component.scss']
})
export class contact_usComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(
    private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    public cupService: ContactUsProfileService,
    private lazyLoadService: LazyLoadScriptService
  ) { 
    this.meta.addTags([
      {name: 'description', content: 'Contact us page of UN - One HR - Salary Survey'},
      {name: 'author', content: 'One HR, Salary Survey'},
      {name: 'keyword', content: 'One HR, Salary Survey, Contact us'}
    ]);
    this.setTitle('UN - Contact us');
  }
  public setTitle(newTitle: string){
    this.title.setTitle(newTitle); 
  }
  slug = 'contact_us';

  template: string;
  contactForm: string;

  public ngOnInit() {
    this.service.get(this.slug).subscribe((response: any) => {
      var str = response.data.html?.map(ele => ele.html).join("");
      this.template = str;
      this.contactForm = `
          <div class="section pt-1">
            <div class="container-fluid">
              <div class="row justify-content-center">
                <div class="col-lg-3 col-md-3 col-sm-4 pt-3" *ngFor="let m of contacts; index as i" (mouseenter)="selected=i"
                  (mouseleave)="selected=-1">
                  <!-- <div class="text-center shadow mt-1" style="border: 1px solid skyblue;padding: 80px 40px 80px 40px; box-shadow: 0 0.5rem 1rem rgb(70 139 203 / 30%) !important; font-size: 1.5em;" [ngStyle]="{'background-color': (selected==i)?'rgb(70 139 203)':'#FFF'}">
                    {{m.name}} 
                  </div>
                  <div *ngIf="selected==i">
                    <div class="text-center shadow border-top-0" style="border: 1px solid skyblue;padding: 20px 40px 20px 40px; font-size: 1.5em; background-color: whitesmoke;">
                      {{m.name}}  Data
                    </div>
                  </div> -->
                  <div class="container d-none d-md-block">
                    <img src="/media/salarySurvey/contactUsProfiles/contactUsProfileImgs/{{m.image}}" alt="Avatar"
                      class="image drop-shadow">
                    <div class="overlay ">
                      <div class="text" style="font-size: 1.2em;">
                        <span>{{m.name}}</span>
                        <div class="text-light" style="font-size: 0.9em;font-weight: 400;">{{m.designation}}</div>
                        <!-- <div><a class="text-light" style="text-decoration: underline;" href="mailto:{{m.email}}">{{m.email}}</a></div> -->
                      </div>
                    </div>
                  </div>

                  <div class="card drop-shadow border-0 m-3 d-md-none">
                    <img class="card-img-top" src="/media/salarySurvey/contactUsProfiles/contactUsProfileImgs/{{m.image}}"
                      alt="Card image cap">
                    <div class="card-body">
                      <h5 class="card-title">{{m.name}}</h5>
                      <p class="card-text">{{m.designation}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isContactTrue">
            <app-contact-form></app-contact-form>
          </div>
      `
      this.compileTemplate();
    });
  }


  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template + this.contactForm,
      changeDetection: ChangeDetectionStrategy.Default
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }


  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,): ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {

      isContactTrue;
      contacts;
      selected = null;

      public ngOnInit() {
        THIS.cupService.getAll().subscribe(res => {
          this.contacts = res.data;
        });
        THIS.cupService.getContactFlag().subscribe(res => {
          this.isContactTrue = res.data.isContactUsTrueSet;
        });
      }

    };
    const decoratedCmp = Component(metadata)(cmpClass);

    const decoratedNgModule = NgModule({ imports: [CommonModule, ReactiveFormsModule, NgxCaptchaModule], declarations: [decoratedCmp, ContactFormComponent] })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }
}
